import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Form, Input, Button, Modal, Picker, Toast } from 'antd-mobile';
import {
  PhoneOutlined,
  CopyOutlined,
  MessageOutlined,
} from '@ant-design/icons';
import { WebviewHttpHandler } from 'shared/webviewHttpHandler';
import { CryptoHandler } from 'shared/cryptoHandler';
import CustomSkeleton from 'pages/mobile/car/ContactSkeleton';
import secureStorage from 'shared/secureStorage';

const webviewHttpHandler = new WebviewHttpHandler(true);
const cryptoHandler = new CryptoHandler();

const ConsultantInfo = () => {
  const [consultant, setConsultant] = useState({
    name: '',
    phone: '',
    mail: '',
    line: '',
  });
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const { plateNumber } = location.state;
  // 取得服務專員資訊
  const getConsultantInfo = () => {
    webviewHttpHandler
      .get(
        `/service/member/sales?line=${secureStorage.getItem(
          'lineUserId'
        )}&category=2&carno=${plateNumber}`
      )
      .then((res) => {
        if (res.success) {
          // 解密人名、手機
          setConsultant({
            name: cryptoHandler.decrypt(res.data.name),
            phone: cryptoHandler.decrypt(res.data.phone),
            mail: res.data.mail,
            line: res.data.line,
          });
          setLoading(false);
        } else {
          console.error(res);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // 复制电子邮件到剪贴板的函数
  const handleCopyMail = (mail) => {
    navigator.clipboard
      .writeText(mail)
      .then(() => {
        // 复制成功后显示Toast提示
        Toast.show({
          content: '已複製',
          icon: <CopyOutlined />,
          duration: 1000, // 持续时间，1000毫秒 = 1秒
        });
      })
      .catch((err) => {
        // 处理可能的复制失败情况
        console.error('複製失败', err);
      });
  };

  useEffect(() => {
    getConsultantInfo();
  }, []);

  return (
    <>
      <div className="bill-container">
        <div className="heading font-bold ml-3">洽詢服務管家</div>
        <div className="appointment-container ">
          {loading ? (
            <CustomSkeleton />
          ) : (
            <>
              <div className="text-align-center my-6">
                <img
                  className="mb-2"
                  src="/images/illustration/consultant-avatar.svg"
                  alt="Description"
                />
                <div className="subheading font-semibold">
                  {consultant.name}
                </div>
              </div>
              <div className="text-body font-normal">
                <div className="my-4">
                  <div className="mb-1">聯絡電話</div>
                  <a
                    href={`tel:+886${consultant.phone
                      .substring(1)
                      .replace(/-/g, '')}`}
                    className="red space-between"
                    style={{ textDecoration: 'none' }}>
                    <div>{consultant.phone}</div>
                    <PhoneOutlined
                      style={{ fontSize: '20px', color: 'currentColor' }}
                    />
                  </a>
                </div>
                <hr></hr>
                <div className="my-4">
                  <div className="mb-1">電子郵件</div>
                  <div
                    className="red space-between"
                    onClick={() => handleCopyMail(consultant.mail)}
                    style={{ cursor: 'pointer' }}>
                    <div>{consultant.mail}</div>
                    <CopyOutlined style={{ fontSize: '20px' }} />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ConsultantInfo;
